import ForWhomForm from '@/modules/common/rater/views/forms/ForWhomForm.vue'
import HasRelationshipView from '@/modules/dental/rater/views/pages/HasRelationshipView.vue'
import RelationshipView from '@/modules/dental/rater/views/pages/RelationshipView.vue'
import StartDateForm from '@/modules/common/rater/views/forms/StartDateForm.vue'
import BirthDatesForm from '@/modules/dental/rater/views/forms/BirthDatesForm.vue'
import HasHealthInsuranceView from '@/modules/dental/rater/views/pages/HasHealthInsuranceView.vue'
import HintView from '@/modules/dental/rater/views/pages/HintView.vue'
import type FormPage from '@/modules/common/common/models/APP/FormPage'

export default {
  ForWhom: {
    form: ForWhomForm,
    next: ['StartDate', 'HasRelationship']
  },
  ForWhom2: {
    form: ForWhomForm,
    next: ['StartDate', 'Relationship']
  },
  HasRelationship: {
    form: HasRelationshipView,
    next: ['Relationship', 'Hint']
  },
  Hint: {
    form: HintView,
    next: ['ForWhom2', 'Relationship', 'StartDate'],
    extra: {
      showActions: false
    }
  },
  Relationship: {
    form: RelationshipView,
    next: ['StartDate']
  },
  StartDate: {
    form: StartDateForm,
    next: ['BirthDatesForm']
  },
  BirthDatesForm: {
    form: BirthDatesForm,
    next: ['HasHealthInsurance'],
    extra: {
      onlyHolderPostalCode: true
    }
  },
  HasHealthInsurance: {
    form: HasHealthInsuranceView,
    next: []
  }
} as Record<string, FormPage>
